import React, { useEffect, useState } from "react";
import { Avatar, Col, Row } from "antd";
import { EditOutlined } from "@ant-design/icons";
import Rewards from "./rewards/rewards";
import Learningchart from "./charts/earningchart";
import { RootState } from "../../../../../store/store";
import { useSelector } from "react-redux";
import Updateusername from "../../../../../components/dashboardpages/updateusername/updateusername";
import useRankings from "../../../../../customhooks/ranking/useRanking";
import { transformAmount } from "../../../../../utils/helper";
import { updateInitialRanking } from "../../../../../api/user/user";
import { updateUser } from "../../../../../store/userSlice/userSlice";
import { useDispatch } from "react-redux";

const Studentprofilemain = () => {
  const { loadingRankings, rankings } = useRankings();
  const dispatch = useDispatch();

  const [nextRanking, setNextRanking] = useState<any>({});
  const [showUpdateUsername, setShowUpdateUsername] = useState(false);
  const [percentage, setPercentage] = useState(0);

  const state = useSelector((state: RootState) => ({
    user: state.user.user,
  }));

  const { user } = state;

  const closeUpdateUsername = () => {
    setShowUpdateUsername(false);
  };

  const runInitRanking = async (rank: any) => {
    try {
      await updateInitialRanking({
        rankId: rank?._id,
      });
      dispatch(
        updateUser({
          user: {
            ...user,
            currentRankId: rank,
          },
        })
      );
    } catch (error) {}
  };

  useEffect(() => {
    if (loadingRankings === false && rankings.length !== 0) {
      let currentTotal = 0;
      if (user?.currentRankId !== undefined) {
        let currentRankingIndex = rankings.findIndex(
          (item: any) => item._id === user?.currentRankId?._id
        );
        if (currentRankingIndex < rankings.length - 1) {
          setNextRanking(rankings[currentRankingIndex + 1]);
          currentTotal = rankings[currentRankingIndex + 1]?.basePointsRequired;
        } else {
          setNextRanking(rankings[rankings.length - 1]);
          currentTotal = rankings[currentRankingIndex - 1]?.basePointsRequired;
        }
      } else {
        runInitRanking(rankings[0]);
        setNextRanking(rankings[1]);
      }

      let calculatedPercentage =
        ((user?.wallet?.funPoints || 0) / currentTotal) * 100;
      setPercentage(calculatedPercentage);
    }

    // eslint-disable-next-line
  }, [loadingRankings, rankings]);

  return (
    <div>
      <Row gutter={16}>
        <Col xs={24} md={24} lg={12}>
          <div className="">
            <div className="custom-primary-bg-two relative rounded-[30px] p-4">
              <div className="flex">
                <div className="relative h-[6.6rem] w-[6rem]">
                  <img
                    src={
                      user?.photoURL === ""
                        ? "/img/vectors/userfemale.svg"
                        : user?.photoURL
                    }
                    alt="profileimage"
                    className="h-full w-full rounded-[25px]"
                  />
                  <div className="custom-primary-bg-two absolute right-[0.3rem] top-[0.3rem] w-fit cursor-pointer rounded-full px-[0.4rem] py-[0.1rem] pb-[0.3rem]">
                    <EditOutlined className="text-appcolorwhite" />
                  </div>
                </div>

                <div className="ml-2">
                  <p className="text-base text-appcolorwhite">
                    {user?.firstName}
                  </p>
                  <p className="mb-2 text-base text-appcolorwhite opacity-[0.7]">
                    {user?.lastName}
                  </p>

                  <div className="custom-white-bg-faint-bg flex items-center justify-between rounded-[25px] px-[0.7rem] py-[0.3rem]">
                    <span className="text-appcolorwhite">{user?.userName}</span>

                    <EditOutlined
                      className="pl-4 cursor-pointer text-appcolorwhite"
                      onClick={() => {
                        setShowUpdateUsername(true);
                      }}
                    />
                  </div>

                  <div className="flex mt-2">
                    <div className="custom-white-bg-faint-bg mr-2 flex items-center justify-between rounded-[25px] px-[0.7rem] py-[0.3rem]">
                      <div className="mr-[0.4rem]">
                        <img
                          src="/img/vectors/key.svg"
                          alt="key"
                          className="h-[0.8rem] w-[0.8rem]"
                        />
                      </div>
                      <span className="ml-2 text-appcolorwhite">
                        {transformAmount(user?.wallet?.funKeys || 0)}
                      </span>
                    </div>

                    <div className="custom-white-bg-faint-bg flex items-center justify-between rounded-[25px] px-[0.7rem] py-[0.3rem]">
                      <div className="mr-[0.4rem]">
                        <img
                          src="/img/vectors/star.svg"
                          alt="star"
                          className="h-[0.8rem] w-[0.8rem]"
                        />
                      </div>
                      <span className="ml-2 text-appcolorwhite">
                        {transformAmount(user?.wallet?.funPoints || 0)}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-2">
                {user?.currentRankId !== undefined ? (
                  <div className="flex items-center ">
                    <div className="mr-[0.6rem]">
                      <img
                        src="/img/vectors/verified.svg"
                        alt="verify"
                        className="w-6 h-6"
                      />
                    </div>

                    <div className="mr-[0.6rem]">
                      <img src="/img/vectors/codecadet.svg" alt="verify" />
                    </div>

                    <div>
                      <p className="text-[18px] font-medium leading-[107%] text-appcolorwhite">
                        {user?.currentRankId?.rankTitle}
                      </p>
                    </div>
                  </div>
                ) : (
                  <span className="ml-[0.3rem] text-sm text-appcolorpurplefaintone">
                    No available ranking.
                  </span>
                )}

                <div className="custom-white-bg-faint relative mt-3 h-[1.7rem] w-full rounded-[30px]">
                  <div
                    className="custom-orange-bg-linear-two flex h-full justify-end rounded-[30px]"
                    style={{
                      width: percentage + "%",
                    }}
                  ></div>

                  <div className="absolute left-[1rem] top-[0.3rem]">
                    <p className="text-sm font-bold text-appcolorwhite ">
                      {transformAmount(
                        nextRanking?.basePointsRequired -
                          user?.wallet?.funPoints || 0
                      )}
                      fp to {nextRanking?.rankTitle}
                    </p>
                  </div>

                  <div className="absolute right-[1rem] top-[0.3rem]">
                    <p className="text-sm font-bold text-appcolorpurplefaintone ">
                      <span className="text-sm text-appcolorwhite">
                        {user?.wallet?.funPoints || 0}
                      </span>
                      /{user?.currentRankId?.basePointsRequired} fp
                    </p>
                  </div>
                </div>

                <div className="custom-black-faint mt-[1rem] flex p-2">
                  <div className="flex w-[50%] border-r border-appcolorwhite">
                    <div className="mr-[0.6rem]">
                      <img src="/img/vectors/html.svg" alt="html" />
                    </div>

                    <div className="mr-[0.6rem]">
                      <img src="/img/vectors/pythonicon.svg" alt="pythonicon" />
                    </div>
                  </div>

                  <div className="flex w-[50%] items-center pl-4">
                    <div className="pr-[0.6rem]">
                      <img
                        src="/img/vectors/smalltrophy.svg"
                        alt="smalltrophy"
                      />
                    </div>

                    <div>
                      <p className="text-[20px] leading-[107%] text-appcolorwhite">
                        #5
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {user?.aiTutorAssignmentId !== undefined &&
              user?.aiTutorDetails !== undefined ? (
                <div className="absolute right-[0.5rem] top-[1rem] cursor-pointer">
                  <img
                    src={user?.aiTutorDetails?.image}
                    alt="ai"
                    className="h-[5.6rem] w-[5.1rem]"
                  />
                </div>
              ) : null}
            </div>

            <div className="mt-8">
              <div className="flex items-center justify-between">
                <div className="flex items-center border-appcolorpurplefaintseven">
                  <p className="mr-2 text-[18px] leading-[107%] text-appcolorblack opacity-[0.5]">
                    Friends
                  </p>
                  <p className="text-[18px] font-bold leading-[107%] text-appcolorblack">
                    30
                  </p>
                </div>

                <div className="border-x border-appcolorpurplefaintseven">
                  <div className="px-[2rem]">
                    <Avatar.Group>
                      {[0, 1, 2, 3, 4, 5].map((item) => (
                        <Avatar
                          key={`friend-${item}`}
                          src="/img/vectors/userfemale.svg"
                          style={{
                            border: "2px solid #FBE0FF",
                            borderRadius: "50%",
                            width: "2.1rem",
                            height: "2.1rem",
                          }}
                        />
                      ))}
                    </Avatar.Group>
                  </div>
                </div>

                <div className="flex">
                  <div>
                    <img src="/img/vectors/flame.svg" alt="flame" />
                  </div>

                  <div className="">
                    <p className="text-[18px] font-bold leading-[107%] text-appcolorblack">
                      2000 FP
                    </p>
                    <p className="text-sm text-appcolorblack">This week</p>
                  </div>
                </div>
              </div>

              <div className="mt-[1.8rem]">
                <div className="flex justify-between mb-4">
                  <p className="text-base font-semibold text-appcolorblack">
                    Recent Rewards
                  </p>
                  <p className="text-base cursor-pointer w-fit text-appcolordeeppurpleone">
                    See all
                  </p>
                </div>

                <div className="flex">
                  {[1, 2, 3, 4, 5].map((item) => (
                    <Rewards
                      key={`reward-${item}`}
                      img={"/img/vectors/glossy.png"}
                    />
                  ))}
                </div>
              </div>

              <div className="mt-[1.8rem]">
                <div className="flex items-stretch">
                  <div className="flex flex-col justify-between">
                    <p className="text-[18px] font-bold leading-[107%] text-appcolorblack">
                      Suggested Friends
                    </p>

                    <div>
                      <Avatar.Group>
                        {[0, 1, 2, 3, 4, 5].map((item) => (
                          <Avatar
                            key={`friend-${item}`}
                            src="/img/vectors/userfemale.svg"
                            style={{
                              border: "2px solid #FBE0FF",
                              borderRadius: "50%",
                              width: "2.1rem",
                              height: "2.1rem",
                            }}
                          />
                        ))}
                      </Avatar.Group>
                    </div>
                  </div>

                  <div className="ml-4">
                    <img src="/img/vectors/unlock.png" alt="unlock" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
        <Col xs={24} md={24} lg={12}>
          <div>
            <div className="mb-12">
              <p className="mb-2 text-[18px] font-semibold leading-[107%] text-appcolorblack">
                Funpoint Earning
              </p>

              <div>
                <Learningchart />
              </div>
            </div>

            <div>
              <p className="mb-2 text-[18px] font-semibold leading-[107%] text-appcolorblack opacity-[0.6]">
                Leaderboard
              </p>

              <div>
                {[1, 3, 43, 54].map((item) => (
                  <div
                    key={`fpt-${item}`}
                    className="mb-0 flex items-center justify-between p-4 hover:rounded-[10px] hover:bg-appcolororangefaint"
                  >
                    <div className="flex items-center">
                      <p className="custom-primary-orange-bg mr-2 rounded-[7px] px-[0.6rem] py-[0.2rem] text-appcolorwhite">
                        1
                      </p>

                      <div className="flex items-center">
                        <Avatar
                          src="/img/vectors/userfemale.svg"
                          style={{
                            border: "2px solid #FBE0FF",
                            borderRadius: "50%",
                            width: "3rem",
                            height: "3rem",
                          }}
                        />

                        <div className="ml-3">
                          <p className="mb-1 text-base font-semibold text-appcolorblack">
                            Ella
                          </p>
                          <p className="text-base font-semibold text-appcolorblack opacity-[0.5]">
                            ellie123
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="">
                      <p className="mb-1 text-base font-semibold text-appcolorblack">
                        40000FP
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Col>
      </Row>

      {showUpdateUsername ? (
        <Updateusername
          open={showUpdateUsername}
          closeModal={closeUpdateUsername}
        />
      ) : null}
    </div>
  );
};

export default Studentprofilemain;
